'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultTo = defaultTo;
exports.toString = toString;
exports.toNumber = toNumber;
exports.toInteger = toInteger;
exports.toFloat = toFloat;
exports.toBoolean = toBoolean;
exports.mapFrom = mapFrom;
exports.using = using;

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function defaultTo(defaultValue) {
  return function (v) {
    return !v ? defaultValue : v;
  };
}

function toString(value) {
  if (value === undefined || value === null) {
    return '';
  }
  return value.toString ? value.toString() : String(value);
}

function toNumber(value) {
  if (isNaN(value)) {
    throw new Error('Cannot transform ' + value + ' into a number.');
  }
  return Number(value);
}

function toInteger(value) {
  if (isNaN(value)) {
    throw new Error('Cannot transform ' + value + ' into an integer.');
  }
  return parseInt(value);
}

function toFloat(value) {
  if (isNaN(value)) {
    throw new Error('Cannot transform ' + value + ' into a float.');
  }
  return parseFloat(value);
}

function toBoolean(value) {
  if (value !== true && value !== 'true' && value !== 'false' && value !== false) {
    throw new Error('Cannot transform ' + value + ' into a boolean.');
  }
  return value === true || value === 'true';
}

function mapFrom(mapping) {
  if (!mapping) {
    throw new Error('The mapping cannot be null.');
  }
  return function (value) {
    if (!mapping[value]) {
      throw new Error('Cannot find value for ' + value + ' in mapping.');
    }
    return mapping[value];
  };
}

function using(fn) {
  if (!fn) {
    throw new Error('The function to use cannot be null.');
  }
  return function (value) {
    return fn(value);
  };
}